// Add your custom JS here.

// Custom navbar toggler

document.addEventListener("DOMContentLoaded", () => {
  const nav = document.getElementById("main-nav");
  const offcanvasEl = document.getElementById("navbarNavOffcanvas");
  if (!nav || !offcanvasEl) return;

  offcanvasEl.addEventListener("show.bs.offcanvas", () => nav.classList.add("offcanvas-open"));
  offcanvasEl.addEventListener("hidden.bs.offcanvas", () => nav.classList.remove("offcanvas-open"));
});

// Close offcanvas BS5

document.addEventListener("DOMContentLoaded", () => {
  const offcanvasEl = document.getElementById("navbarNavOffcanvas");
  if (!offcanvasEl) return;

  const closeBtn = offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"]');
  if (!closeBtn) return;

  const isOffcanvasOpen = () => offcanvasEl.classList.contains("show");

  const getHashFromLink = (a) => {
    const href = (a.getAttribute("href") || "").trim();
    if (!href) return "";

    if (href.startsWith("#")) return href;

    try {
      const url = new URL(a.href, window.location.href);
      return url.hash || "";
    } catch {
      return "";
    }
  };

  document.addEventListener(
    "click",
    (e) => {
      if (!isOffcanvasOpen()) return;
      if (!offcanvasEl.contains(e.target)) return;

      const link = e.target.closest("a");
      if (!link) return;

      if (link.classList.contains("dropdown-toggle")) return;

      const hash = getHashFromLink(link);

      if (hash && hash !== "#") {
        closeBtn.click();
        return;
      }

      closeBtn.click();
    },
    true
  );

  window.addEventListener("hashchange", () => {
    if (isOffcanvasOpen()) closeBtn.click();
  });
});

// Navbar

document.addEventListener("DOMContentLoaded", () => {
  const nav = document.getElementById("main-nav");
  if (!nav) return;

  const threshold = 80;

  const onScroll = () => {
    if (window.scrollY > threshold) {
      nav.classList.add("is-scrolled");
    } else {
      nav.classList.remove("is-scrolled");
    }
  };

  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
});

// Popup

document.addEventListener('DOMContentLoaded', function () {
  const modalEl = document.getElementById('remotePageModal');
  if (!modalEl) return;

  const titleEl = modalEl.querySelector('.modal-title');
  const contentEl = modalEl.querySelector('.js-modal-content');
  if (!contentEl) return;

  const cache = new Map();

  document.addEventListener('click', async function (e) {
    const trigger = e.target.closest('[data-bs-toggle="modal"][data-bs-target="#remotePageModal"]');
    if (!trigger) return;

    const pageId = trigger.getAttribute('data-popup-page');
    if (!pageId) {
      titleEl.textContent = 'BIO';
      contentEl.innerHTML = 'None data-popup-page.';
      return;
    }

    // natychmiast pokaż loading
    titleEl.textContent = 'BIO';
    contentEl.innerHTML = 'loading…';

    // cache
    if (cache.has(pageId)) {
      const cached = cache.get(pageId);
      titleEl.textContent = cached.title;
      contentEl.innerHTML = cached.content;
      return;
    }

    try {
      const ajaxUrl =
        (window.sitePopup && window.sitePopup.ajaxUrl)
          ? window.sitePopup.ajaxUrl
          : (window.location.origin + '/wp-admin/admin-ajax.php');

      const url = new URL(ajaxUrl);
      url.searchParams.set('action', 'load_popup_page');
      url.searchParams.set('page_id', pageId);

      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const data = await res.json();

      if (!data.success) throw new Error('WP returned success:false');

      const payload = {
        title: data.data.title || 'Info',
        content: data.data.content || ''
      };

      cache.set(pageId, payload);

      titleEl.textContent = payload.title;
      contentEl.innerHTML = payload.content;
    } catch (err) {
      console.error('Popup load error:', err);
      titleEl.textContent = 'Error';
      contentEl.innerHTML = 'Failed to load content.';
    }
  });
});

// Forminator Tooltip

(function () {
  function removeTitleFromLastOption() {
    const last = document.querySelector('#checkbox-1 label.forminator-checkbox:last-of-type');
    if (last && last.hasAttribute('title')) {
      last.removeAttribute('title');
    }
  }

  // run now + after load
  removeTitleFromLastOption();
  window.addEventListener('load', removeTitleFromLastOption);

  // keep removing if Forminator re-renders / re-adds title
  const obs = new MutationObserver(removeTitleFromLastOption);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();